import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type BackgroundSelection =
  | { kind: 'none' }
  | { kind: 'blur' }
  | { kind: 'image'; imageId: string }

// Выбор фона переживает перезаход в комнату; это пресет, не секрет — localStorage.
interface BackgroundState {
  selection: BackgroundSelection
  setNone: () => void
  setBlur: () => void
  setImage: (imageId: string) => void
}

export const useBackgroundSelection = create<BackgroundState>()(
  persist(
    (set) => ({
      selection: { kind: 'none' },
      setNone: () => set({ selection: { kind: 'none' } }),
      setBlur: () => set({ selection: { kind: 'blur' } }),
      setImage: (imageId) => set({ selection: { kind: 'image', imageId } }),
    }),
    { name: 'telemost.background' },
  ),
)
